/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const IconMore = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
    <path
      fill='currentColor'
      d='M9.2 8.2a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0M4.6 8.2a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0M13.8 8.2a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0'
    />
  </svg>
)
